import { Component, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { MatTableDataSource, MatSnackBar } from '@angular/material';
import { Imagen } from '../../../interfaces/imagen';
import { PermisoService } from '../../../providers/permiso.service';
import { DomSanitizer } from '@angular/platform-browser';
import { GaleriaService } from '../../../providers/galeria.service';

@Component({
  selector: 'app-ver-galeria',
  templateUrl: './ver-galeria.component.html',
  styleUrls: ['./ver-galeria.component.scss']
})
export class VerGaleriaComponent implements OnInit {

  actualizarTablaTimeoutImagenes: any; // prevenir muchos llamados consecutivos al webserver
  flag_primera_carga_imagenes: boolean = true; // primera solicitud
  imagenes: Imagen[] = <Imagen[]>[];
  tablaImagenesColumnas = ["ID", "imagen", "tipo", "titulo"];
  imagenesDataSource = new MatTableDataSource();
  getImagenSuscripcion = new Subscription();
  cargandoImagenes: boolean = false;

  constructor(
    private galeriaService: GaleriaService,
    private _sanitizer: DomSanitizer,
    private permisoService: PermisoService,
    private snackBar: MatSnackBar
  ) {
    this.permisoService.tienePermiso('GALERIA-ACCIONES').then(tienePermiso => {
      if (tienePermiso) {
        this.tablaImagenesColumnas.push('acciones');
      }
    });
    this.permisoService.tienePermiso('GALERIA-ORDEN').then(tienePermiso => {
      if (tienePermiso) {
        this.tablaImagenesColumnas.push('orden');
      }
    });
  }

  ngOnInit(): void {
    this.actualizarTabla();
  }

  getSecureUrl(url) {
    return this._sanitizer.bypassSecurityTrustStyle(`url(${url})`);
  }

  getSecureVideoUrl(url) {
    return this._sanitizer.bypassSecurityTrustResourceUrl(url);
  }

  getVideoIdFromUrl(url) {
    let video_id = url.split('v=')[1];

    if (video_id) {
      let ampersandPosition = video_id.indexOf('&');
      if (ampersandPosition != -1) {
        return video_id.substring(0, ampersandPosition);
      }

      return video_id;
    }

    return '';
  }

  getVideoThumbnail(src) {
    let video_id = this.getVideoIdFromUrl(src);
    return 'http://img.youtube.com/vi/' + video_id + '/2.jpg';
  }

  actualizarTabla(): void {
    clearTimeout(this.actualizarTablaTimeoutImagenes);
    this.actualizarTablaTimeoutImagenes = setTimeout(() => {

      if (this.getImagenSuscripcion && !this.getImagenSuscripcion.closed) {
        this.getImagenSuscripcion.unsubscribe();
      }

      // datos de las imagenes
      this.cargandoImagenes = true;
      this.imagenes = <Imagen[]>[];
      this.getImagenSuscripcion = this.galeriaService
        .getImagenes(
          {
            page: null,
            pageSize: null
          },
          {
            sort: null,
            order: null
          },
          {
            generico: ''
          }
        )
        .subscribe(
          respuesta => {
            if (respuesta) {
              if (respuesta.estado == 1 && respuesta.data && respuesta.data.fotos) {
                respuesta.data.fotos.forEach((foto) => {
                  this.imagenes.push(<Imagen>{
                    IdImagen: foto.id,
                    destacada: !!+foto.destacada,
                    src: foto.link,
                    orden: +foto.orden,
                    titulo: foto.titulo,
                    tipo: foto.tipo
                  });
                });

                this.imagenesDataSource.data = this.imagenes;
              }
            }

            this.cargandoImagenes = false;
          },
          () => {
            this.cargandoImagenes = false;
            this.flag_proxima_actualizacion = false;
          },
          () => {
            this.cargandoImagenes = false;
            this.flag_proxima_actualizacion = false;
          }
        );
    }, (this.flag_primera_carga_imagenes ? 0 : 220));

    this.flag_primera_carga_imagenes = false;
  }

  IdEfecto: number | string;
  flag_proxima_actualizacion: boolean = false;
  /**
   * agregar efecto a una fila modificada
   * @param id fila con efecto
   */
  rowEfecto(id: number | string): void {
    this.IdEfecto = id;

    // cuando se pone en false el flag, terminó de actualizar la tabla
    this.flag_proxima_actualizacion = true;
    let verificarActualizado = setInterval(() => {
      // si terminó de cargar
      if (!this.flag_proxima_actualizacion) {
        // dejar de verificar
        clearInterval(verificarActualizado);
        // fin efecto
        setTimeout(() => {
          this.IdEfecto = null;
        }, 500);
      }
    }, 300);
  }

  ngOnDestroy() {
    if (this.getImagenSuscripcion && !this.getImagenSuscripcion.closed) {
      this.getImagenSuscripcion.unsubscribe();
    }
  }
}
